import React from "react";
import InteractiveMap from "./InteractiveMap";
import StaticText from "../components/StaticText";
import greenTicketsLogo from "../resources/images/green-tickets-logo-name.png";
import {Button, Form, Input} from "semantic-ui-react";
import {connect} from "react-redux";
import * as StaticActions from "../actions/StaticActions";

class UnderConstruction extends React.Component {

    state = {
        mail: "",
    };

    saveMail() {
        const {mail} = this.state;
        this.props.saveEmail(mail);
        this.setState({mail: ""});
    }

    render() {

        const {mail} = this.state;
        const {saving, saved} = this.props.newsletterStatus;

        return <div className="full-map">

            <div className="map-container">

                <InteractiveMap beta/>

                <div className="under-construction-text">
                    <h1>SailScanner</h1><br/>
                    <StaticText label="under-construction"/><br/><br/>
                    <strong>Can't wait to see what we're building?</strong><br/>Sign up for our newsletter and we'll let
                    you know as soon as we go live!<br/><br/>
                    {saved ? <div>
                            <em>Thanks, we'll let you know!</em>
                        </div> :
                        <Form onSubmit={() => this.saveMail()}>
                            <Input value={mail} onChange={(e) => this.setState({mail: e.target.value})} size="mini"
                                   placeholder="E-mail address" style={{width: "400px"}}/>{" "}
                            <Button type="submit" loading={saving}>Sign up</Button>
                        </Form>
                    }
                </div>

                <div className="absolute-footer">
                    <a href="https://www.greentickets.app" target="_blank">Powered by <img src={greenTicketsLogo}
                                                                                           alt="Green Tickets - Building the European travel planner of the future."/></a>
                </div>

            </div>

        </div>
    }
}


export default connect(state => ({
    newsletterStatus: state.staticTexts.newsletter,
}), dispatch => ({
    saveEmail: (mail) => dispatch(StaticActions.saveNewsletterMail(mail)),
}))(UnderConstruction)


// WEBPACK FOOTER //
// ./src/homepage/UnderConstruction.js